import React from 'react';
import Markdown from 'react-markdown';
import { parseEntityUri } from './entityLinkUtils';
import { EntityLink } from './EntityLink';
import styles from '../ChatWidget.module.scss';

interface ChatMarkdownLinkProps {
  href?: string;
  children?: React.ReactNode;
}

function ChatMarkdownLink(props: ChatMarkdownLinkProps) {
  const { href, children } = props;
  const entityRef = parseEntityUri(href);

  if (entityRef) {
    return (
      <EntityLink type={entityRef.type} id={entityRef.id}>
        {children}
      </EntityLink>
    );
  }

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={styles.externalLink}>
      {children}
    </a>
  );
}

function urlTransform(url: string): string | null {
  // Allow nekst:// scheme URLs to pass through without sanitization
  if (url.startsWith('nekst://')) {
    return url;
  }
  // For all other URLs, use default behavior (allows http, https, mailto, tel)
  const protocols = ['http', 'https', 'mailto', 'tel'];
  const protocol = url.split(':')[0]?.toLowerCase();
  if (protocols.includes(protocol)) {
    return url;
  }
  // Block other protocols
  return null;
}

interface ChatMarkdownContentProps {
  content: string;
}

export function ChatMarkdownContent(props: ChatMarkdownContentProps) {
  const { content } = props;

  return (
    <Markdown
      urlTransform={urlTransform}
      components={{
        a: (linkProps) => (
          <ChatMarkdownLink href={linkProps.href}>
            {linkProps.children}
          </ChatMarkdownLink>
        ),
      }}
    >
      {content}
    </Markdown>
  );
}
